export default class PaymentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.status = data.status || '';
    this.description = data.description || '';

    this.amount_due_cents = data.amount_due_cents || 0;
    this.can_pay_with_group_credit = data.can_pay_with_group_credit || false;
    this.can_pay_with_individual_session_credit = data.can_pay_with_individual_session_credit || false;
    this.credit_used = !!data.credit_used;

    this.paid_on_date = data.paid_on_date ? new Date(data.paid_on_date) : null;
    this.created = data.created ? new Date(data.created) : null;
    this.due_date = data.due_date ? new Date(data.due_date) : null;
    this.appointment_date = data.appointment_date ? new Date(data.appointment_date) : null;

  }

  get statusStr() {
    if (this.status === 'pending') {
      return 'Not Paid';
    } else if (this.status === 'paid') {
      return 'Paid';
    }

    return this.status; // todo:
  }

  get stripeSuccessUrl() {
    return `${document.location.origin}/stripe/payment/${this.id}/success`;
  }
  get stripeErrorUrl() {
    return `${document.location.origin}/stripe/payment/${this.id}/error`;
  }
}
